import React, { ReactElement, useContext, useEffect, useState } from 'react';

import { dashboardPagesMenu, evoHuntPages } from '../../../../../menu';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ReactiveDrawerMenu from '../menu/ReactiveDrawerMenu';
import { Badge, IconButton } from '@mui/material';
import evohuntLogo from '../../../../../assets/evohunt_logo.png';

import { ArrowIcon, HomeIconWhite, MessageIconWhite, NotificationIconWhite } from '../../../../../assets/ui-icons/header-icon';
import { getLoggedAvatar, getLoggedUserId, getLoggedUserRole } from '../../../../../common/function/utilities';
import { ROLE } from '../../../../../constants/constants';
import { IMAGES_URL } from '../../../../../constants/environment.constants';
import { UserRoleContext, UserRoleContextProps } from '../../../../../contexts/userRoleContext';
import { getProfileDefaultIcon } from '../../../../../utils/profile';
import { AlertsContext, AlertsContextProps } from '../../../../../contexts/alertsContext';
import { useTimer } from '../../../../../contexts/timerContext';
import { formatTime } from '../../../../../utils/string';
import ConfirmModal from '../modal/ConfirmModal';
import { HtmlTooltip } from '../../../../../utils/tooltip';
import { removeFromLocalStorage } from '../../../../../utils/storage.util';
import IconFaq from '../../../../../assets/new-icons/C04_FAQ.svg';
import { t } from 'i18next';

interface IEvoHuntDesktopHeaderProps {
	handleBack: () => void;
}

const EvoHuntDesktopHeader: React.FC<IEvoHuntDesktopHeaderProps> = (props: IEvoHuntDesktopHeaderProps): ReactElement => {
	const navigate = useNavigate();
	const location = useLocation();
	const { role } = useContext<UserRoleContextProps>(UserRoleContext);
	const { alerts } = useContext<AlertsContextProps>(AlertsContext);
	const [searchParams] = useSearchParams();

	const { timeLeft, isRunning, resetTimer } = useTimer();
	const [alertTimer, setAlertTimer] = useState<boolean>(false);
	const [alertTimerCallback, setAlertTimerCallback] = useState<string | undefined>(undefined);

	const mainPages: boolean =
		location.pathname === '/' ||
		location.pathname === '/messaggi' ||
		location.pathname === '/notifiche' ||
		location.pathname === '/tipsTabbed' ||
		location.pathname === '/aziendaProfileHome' ||
		location.pathname === '/userProfileCandidato' ||
		location.pathname === '/userProfileStartup' ||
		location.pathname === '/terms-and-conditions' ||
		location.pathname === '/privacy-policy' ||
		location.pathname === '/cookies-policy' ||
		(location.pathname === '/preview' && !searchParams.get('back')) ||
		(location.pathname === '/blind-preview' && !searchParams.get('back')) ||
		(location.pathname === '/candidate-preview' && !searchParams.get('back')) ||
		(location.pathname === '/query-preview' && !searchParams.get('back')) ||
		(location.pathname === '/idea-preview' && !searchParams.get('back')) ||
		location.pathname === '/registration' ||
		(location.pathname === '/Login' && !!searchParams.get('company')) ||
		location.pathname === '/homeCandidato' ||
		location.pathname === '/homeAzienda' ||
		location.pathname === '/homeIdeatore' ||
		location.pathname === '/homeStartup';

	useEffect((): void => {
		if (!alertTimer) {
			alertCallback();
		}
	}, [alertTimer]);

	const alertCallback = (): void => {
		removeFromLocalStorage('currentPanel');
		removeFromLocalStorage('softSkills');

		switch (alertTimerCallback) {
			case 'home':
				handleHomeClick();
				break;
			case 'messages':
				handleMessagesClick();
				break;
			case 'notifications':
				handleNotificationClick();
				break;
			case 'advisor':
				handleAdvisorClick();
				break;
			case 'profile':
				imgProfileClickHandler();
				break;
		}
	}

	const handleHomeClick = (): void => {
		if (isRunning) {
			setAlertTimer(true);
			setAlertTimerCallback('home');
		} else {
			if (getLoggedUserRole() === ROLE.USER) {
				navigate(`../${evoHuntPages.evohunt.subMenu.homeCandidato.path}`, {replace: true});
			} else if (getLoggedUserRole() === ROLE.COMPANY) {
				navigate(`../${evoHuntPages.evohunt.subMenu.homeAzienda.path}`, {replace: true});
			} else if (getLoggedUserRole() === ROLE.IDEATOR) {
				navigate(`../${evoHuntPages.evohunt.subMenu.homeIdeatore.path}`, {replace: true});
			} else if (getLoggedUserRole() === ROLE.STARTUP) {
				navigate(`../${evoHuntPages.evohunt.subMenu.homeStartup.path}`, {replace: true});
			} else {
				navigate(`../${dashboardPagesMenu.evohunt.path}`);
			}
		}
	};

	const handleMessagesClick = (): void => {
		if (isRunning) {
			setAlertTimer(true);
			setAlertTimerCallback('home');
		} else {
			navigate(`../${evoHuntPages.evohunt.subMenu.messaggi.path}`, { replace: true });
		}
	};

	const handleNotificationClick = (): void => {
		if (isRunning) {
			setAlertTimer(true);
			setAlertTimerCallback('home');
		} else {
			navigate(`../${evoHuntPages.evohunt.subMenu.notifiche.path}`, { replace: true });
		}
	};

	const handleAdvisorClick = (): void => {
		if (isRunning) {
			setAlertTimer(true);
			setAlertTimerCallback('home');
		} else {
			if (role === ROLE.USER) {
				navigate(`../${evoHuntPages.evohunt.subMenu.candidatureTestVideoEducational.subMenu.educational.path}`, { replace: true });
			} else {
				navigate(`../${evoHuntPages.evohunt.subMenu.tipsTabbed.path}`, {
					replace: true
				});
			}
		}
	};

	const imgProfileClickHandler = (): void => {
		if (isRunning) {
			setAlertTimer(true);
			setAlertTimerCallback('home');
		} else {
			if (role === ROLE.USER) {
				navigate(`../${evoHuntPages.evohunt.subMenu.userProfile.path}`, { replace: true });
			} else if (role === ROLE.COMPANY) {
				navigate(`../${evoHuntPages.evohunt.subMenu.aziendaProfileHome.path}`, { replace: true });
			} else if (role === ROLE.IDEATOR) {
				navigate(`../${evoHuntPages.evohunt.subMenu.userProfile.path}`, { replace: true });
			} else if (role === ROLE.STARTUP) {
				navigate(`../${evoHuntPages.evohunt.subMenu.userProfileStartup.path}`, { replace: true });
			}
		}
	};

	const handleUserRoleIcon = (): string => {
		return IconFaq;
		/*switch (role) {
			case ROLE.USER:
				return ApplicantIconWhite;
			case ROLE.IDEATOR:
				return IdeatoreIconWhite;
			default:
				return AdvisorIconWhite;
		}*/
	};
	
	const buttonMessages = (): ReactElement => {
		return <HtmlTooltip title={t('header.messages')}>
			<IconButton
				aria-label='messages'
				className='cta'
				onClick={handleMessagesClick}>
				<img src={MessageIconWhite} alt='messagesIcon' />
			</IconButton>
		</HtmlTooltip>;
	}

	const buttonNotifications = (): ReactElement => {
		return <HtmlTooltip title={t('header.notifications')}>
			<IconButton
				aria-label='notifications'
				className='cta'
				onClick={handleNotificationClick}>
				<img src={NotificationIconWhite} alt='notificationIcon' />
			</IconButton>
		</HtmlTooltip>;
	}

	return (
		<div className={`${location.pathname === '/' ? 'element-display-none' : 'header_container'}`}>
			<div className='curved_shadow_container'></div>
			<div className='line_shadow_container'></div>
			<div className='logo_container'>
				{mainPages || isRunning ? (
					''
				) : (
					<IconButton
						edge={false}
						className='backButton'
						color='inherit'
						aria-label='Back'
						onClick={(): void => {
							window.scrollTo(0, 0);
							props.handleBack();
						}}>
						<img src={ArrowIcon} alt='EvoBackIcon' />
					</IconButton>
				)}

				<img src={evohuntLogo} alt='evohunt_logo' onClick={handleHomeClick} style={{ width: '12rem' }} className='cursor-link' />
			</div>

			<div className='cta-container'>
				<div className='cta-subcontainer'>
					{getLoggedUserId() ? (
						<>
							{isRunning && (
								<HtmlTooltip title={t('header.timer')}>
									<h2 className='text-end color-white' style={{ width: '10rem' }}>
										<strong>{formatTime(timeLeft)}</strong>&nbsp;⏳
									</h2>
								</HtmlTooltip>
							)}

							<HtmlTooltip title={t('header.home')}>
								<IconButton aria-label='home' className='cta' onClick={handleHomeClick}>
									<img src={HomeIconWhite} alt='homeIcon' />
								</IconButton>
							</HtmlTooltip>

							{alerts?.messages ? (
								<Badge badgeContent={alerts?.messages} color='error'>
									{buttonMessages()}
								</Badge>
							) : (
								buttonMessages()
							)}

							{alerts?.notifications ? (
								<Badge badgeContent={alerts?.notifications} color='error'>
									{buttonNotifications()}
								</Badge>
							) : (
								buttonNotifications()
							)}

							<HtmlTooltip title={t('header.faq')}>
								<IconButton aria-label='advisor' className='cta' onClick={handleAdvisorClick}>
									<img src={handleUserRoleIcon()} alt='userRole-icon' className='svg-white' style={{ width: '2.25rem' }} />
								</IconButton>
							</HtmlTooltip>

							<HtmlTooltip title={t('header.profile')}>
								<IconButton aria-label='profile' onClick={imgProfileClickHandler} className='profile-pic'>
									<div style={{ backgroundColor: getLoggedAvatar() ? 'white' : 'transparent' }}>
										<img src={getLoggedAvatar() ? IMAGES_URL + getLoggedAvatar() : getProfileDefaultIcon(role!, false)} alt='profileIcon' style={{ padding: getLoggedAvatar() ? '' : '.5rem' }} />
									</div>
								</IconButton>
							</HtmlTooltip>

							{!isRunning && <ReactiveDrawerMenu iconSize='2.5rem' color='white' />}
						</>
					) : (
						<div style={{ width: '8rem' }}></div>
					)}
				</div>
			</div>

			<ConfirmModal
				title={t('common.timer.title')}
				subtitle={t('common.timer.subtitle')}
				state={alertTimer}
				setState={setAlertTimer}
				confirmHandler={(): void => {
					resetTimer();
					setAlertTimer(false);
				}}
				abortHandler={(): void => {
					setAlertTimer(false);
					setAlertTimerCallback(undefined);
				}}
			/>
		</div>
	);
};

export default EvoHuntDesktopHeader;
